<template>
  <div
    class="flex h-[3.6rem] items-center gap-x-4 rounded-2xl bg-gray-200 px-4 font-medium"
  >
    <button
      class="rounded-2xl px-16 py-4"
      :class="{ 'bg-black !text-white ': !internalModelValue }"
      @click="toggleModelValue"
    >
      {{ $t('search.cardView') }}
    </button>

    <button
      class="rounded-2xl px-16 py-4"
      :class="{ 'bg-black !text-white ': internalModelValue }"
      @click="toggleModelValue"
    >
      {{ $t('search.mapView') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import type { Emits, Props } from './HotelResultsViewSwitch.types'

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const internalModelValue = useVModel(props, 'modelValue', emit)

function toggleModelValue() {
  internalModelValue.value = !internalModelValue.value
}
</script>
